import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyVideoArchLayout = loadable(() => import(/* webpackChunkName: "content/guest/header/videoArch" */ './VideoArchLayout'), 'VideoArchLayout');
